var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-header",attrs:{"flex":"cross:center box:last"}},[_c('a',{staticClass:"logo",attrs:{"flex":"cross:center"}},[_c('img',{staticClass:"logoWrap",attrs:{"src":"//static.12301.cc/assets/build/images/pft-header-logo.png","alt":""}})]),_c('div',{attrs:{"flex":"cross:center"}})])
}]

export { render, staticRenderFns }